import {
  EventType,
  PublicClientApplication,
  type AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

/**
 * Web Crypto API (required by MSAL for PKCE) is only available in secure contexts:
 * - https://
 * - http://localhost
 * - http://127.0.0.1
 * When accessed via http://<LAN-IP> (e.g. http://192.168.9.196:3000), crypto.subtle
 * is undefined and MSAL throws crypto_nonexistent. We only create the instance when
 * crypto is available so the app loads without crashing; Microsoft login will be
 * unavailable until the app is served over HTTPS or localhost.
 */
function isSecureContext(): boolean {
  if (typeof window === "undefined") return false;
  if (window.isSecureContext) return true;
  try {
    return (
      typeof crypto !== "undefined" && typeof crypto.subtle !== "undefined"
    );
  } catch {
    return false;
  }
}

let _instance: PublicClientApplication | null = null;

if (isSecureContext()) {
  _instance = new PublicClientApplication(msalConfig);
  _instance.addEventCallback((event) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
      event.payload
    ) {
      const payload = event.payload as AuthenticationResult;
      if (payload.account && _instance) {
        _instance.setActiveAccount(payload.account);
      }
    }
  });
}

export const msalInstance: PublicClientApplication | null = _instance;
